import * as React from 'react';

import classNames from 'classnames';

interface IColumnsProps {
	className?: string;
	isHidden?: boolean;
}

export default class Columns extends React.Component<IColumnsProps, {}> {
	public render() {
		const { className, isHidden } = this.props;

		if (isHidden) {
			return null;
		}

		const classes = classNames('columns', className ? className : '');
		return <div className={classes}>{this.props.children}</div>;
	}
}
